import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { TagsRepository } from '@efficiently/client-api-tags';

import { TagsGqlRepository } from './repositories/tags-gql.repository';

export function provideTagsDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: TagsRepository, useClass: TagsGqlRepository }]);
}
